import { TFunction } from "i18next";
import { z } from "zod";

export const getFlowTestInterpretationFormSchema = (t: TFunction) => {
  return z.object({
    measuredCaptureId: z
      .number({
        required_error: t("flow-tests.flow-test-interpretation.errors.measured-capture-required"),
        invalid_type_error: t("flow-tests.flow-test-interpretation.errors.measured-capture-required"),
      })
      .positive()
      .min(1, { message: t("flow-tests.flow-test-interpretation.errors.measured-capture-required") }),
    interpretationMethodId: z
      .number({
        required_error: t("flow-tests.flow-test-interpretation.errors.interpretation-method-required"),
        invalid_type_error: t("flow-tests.flow-test-interpretation.errors.interpretation-method-required"),
      })
      .positive()
      .min(1, { message: t("flow-tests.flow-test-interpretation.errors.interpretation-method-required") }),
    variableId: z
      .number({
        required_error: t("flow-tests.flow-test-interpretation.errors.variable-required"),
        invalid_type_error: t("flow-tests.flow-test-interpretation.errors.variable-required"),
      })
      .positive()
      .min(1, { message: t("flow-tests.flow-test-interpretation.errors.variable-required") }),
    value: z
      .number({
        required_error: t("flow-tests.flow-test-interpretation.errors.value-required"),
        invalid_type_error: t("flow-tests.flow-test-interpretation.errors.value-required"),
      }),
    flag: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
  });
};

export type FlowTestInterpretationForm = z.infer<ReturnType<typeof getFlowTestInterpretationFormSchema>>;